export default __webpack_public_path__ + "static/speed-gauge-03-tr-3815d5777081159df818541a4040475e.png";